import React, { useCallback, useEffect, useRef, useState } from 'react';
import { 
    ChevronDown, 
    ChevronRight, 
    Plus, 
    Search,
    X ,
    SlidersHorizontal,
    ShoppingBag
} from 'lucide-react'; 

import ProductDetailsModal from '../components/ProductDetailsModal'; 
import CartPage from '../components/CartPage'; 

import HomeOfferCarousel from '../components/HomeOfferCarousel';

import { apiUrl, assetsUrl } from '../config/Config';
import axios from 'axios';
import Spinner from "react-activity/dist/Spinner";
import noimage from '../assets/images/no-image.jpeg';
import { useSelector } from "react-redux";
import tanuragalogo from "../assets/images/tanuraga-logo.png";

// --- Data Definitions (No Change) ---

// --- End Data Definitions ---


const HomePage = () => {
    const cartdata = useSelector((store) => store.userReducer.cartdata);
    const productListingRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isCartPageOpen, setIsCartPageOpen] = useState(false);

    const [categorydata, setcategorydata] = useState([]);
    const [activecatindex, setactivecatindex] = useState(0);
    const [activesubcatindex, setactivesubcatindex] = useState(null);

    const [productsdata, setproductsdata] = useState([]);
    const [productloading, setproductloading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [activeSearch, setActiveSearch] = useState("");

    // ✅ FILTER SIDEBAR STATE (Mobile)
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const toggleFilterSidebar = () => {
        setIsFilterOpen(!isFilterOpen);
    };

    const closeFilterSidebar = () => setIsFilterOpen(false);

    const getDiscountPercent = (mrp, sell) => {
        if (!mrp || !sell || mrp <= 0 || sell <= 0) return 0;
      
        const discount = ((mrp - sell) / mrp) * 100;
      
        return Math.round(discount); // or Math.floor / toFixed(2)
    };

    const getCartTotal = () => {
        const newData = [...cartdata];
        return newData.reduce((total, item) => {
          return total + (item.quantity * item.price);
        }, 0);
    };


    const handleOpenModal = (product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
        closeFilterSidebar();
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };

    const handleToggleCartPage = () => {
        setIsCartPageOpen(!isCartPageOpen);
    };

    const scrollToProductListing = () => {
        if (!productListingRef.current) {
            return;
        }

        const navbar = document.querySelector(".custom-navbar");
        const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 0;
        const extraGap = 18;
        const targetTop = productListingRef.current.getBoundingClientRect().top + window.scrollY - navbarHeight - extraGap;

        window.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: "smooth",
        });
    };

    const handleCategoryClick = (index) => {
        // setActiveCategory(categoryName);
        // setActiveSubcategory(null); 
        var prevdata = categorydata[index];
        console.log('prevdata >>', prevdata);
        if(prevdata?.subcategories?.length > 0) {
            handleSubcategoryClick(prevdata?.subcategories[0]?.id)
        }
        setactivecatindex(index);
    };

    const handleSubcategoryClick = (index) => {
        setSearchTerm("");
        setActiveSearch("");
        setactivesubcatindex(index);
        fetchproducts(index)
        closeFilterSidebar();
    };

    const fetchproducts = useCallback(async(id) => {
        setproductloading(true);
        console.log('id >>', id);
        var data = {
            subcategoryid: id
        }
        const headers = {
            headers: {
              "Content-Type": "application/json",
            },
        };
        await axios
        .post(apiUrl + "fetchsubcategoryproducts",data, headers)
        .then((res) => {
            if (res.data.data?.length > 0) {
                setproductsdata(res.data.data);
                setproductloading(false);
            } else {
                setproductsdata([]);
                setproductloading(false);
            }
        })
        .catch((err) => {
            setproductsdata([]);
            setproductloading(false);
            alert(err.message);
          });
    }, []);

    const handlesearchproducts = async(event) => {
        event.preventDefault();
        const keyword = searchTerm.trim();
        if (!keyword) {
            return;
        }

        setproductloading(true);
        setActiveSearch(keyword);
        closeFilterSidebar();

        const headers = {
            headers: {
              "Content-Type": "application/json",
            },
        };

        await axios
        .post(apiUrl + "searchproducts", { search: keyword }, headers)
        .then((res) => {
            setproductsdata(Array.isArray(res.data.data) ? res.data.data : []);
            setproductloading(false);
            window.requestAnimationFrame(scrollToProductListing);
        })
        .catch((err) => {
            setproductsdata([]);
            setproductloading(false);
            alert(err.message);
            window.requestAnimationFrame(scrollToProductListing);
        });
    }

    const clearSearch = () => {
        setSearchTerm("");
        setActiveSearch("");
        if (activesubcatindex) {
            fetchproducts(activesubcatindex);
        }
    };

    const handlefetchcategories = useCallback(async() => {
        const headers = {
            headers: {
              "Content-Type": "application/json",
            },
        };
        await axios
        .get(apiUrl + "fetchallcategories", headers)
        .then((res) => {
            if (res.data.data?.length > 0) {
                setcategorydata(res.data.data);
                var firstcat = res.data.data[0];
                if(firstcat?.subcategories?.length > 0) {
                    setactivesubcatindex(firstcat?.subcategories[0]?.id);
                    fetchproducts(firstcat?.subcategories[0]?.id);
                } else {
                    setactivesubcatindex(null);
                }
            } else {
                setcategorydata([]);
                setactivesubcatindex(null);
                
            }
        })
        .catch((err) => {
          alert(err.message);
        });
    }, [fetchproducts]);

    useEffect(() => {
        handlefetchcategories();
    }, [handlefetchcategories])


    return (
    
        <div>

            <section>
                <div className="home-banner-container">
                    <div className="home-banner-left-decoration"></div>

                    <div className="home-banner-content">
                        <h1 className="home-banner-title">Tanuraaga festive wear, crafted for graceful everyday moments</h1>
                        <p className="home-banner-subtitle">
                            Explore sarees, kurtis, co-ords and occasion-ready styles selected for comfort, detail and quick checkout.
                        </p>

                        <form className="home-banner-search-form" onSubmit={handlesearchproducts}>
                            <input
                                type="text"
                                placeholder="Search sarees, kurtis, dresses..."
                                className="home-banner-search-input"
                                value={searchTerm}
                                onChange={(event) => setSearchTerm(event.target.value)}
                            />
                            {searchTerm && (
                              <button type="button" className="home-banner-search-clear" onClick={clearSearch} aria-label="Clear search">
                                <X size={18} />
                              </button>
                            )}
                            <button type="submit" className="home-banner-search-button">
                                <Search size={20} /> 
                                <span>Search</span>
                            </button>
                        </form>
                    </div>

                    {
                      cartdata && cartdata?.length ?
                      <div className="home-banner-right-decoration">
                        <div 
                          className="home-banner-cart-widget"
                          onClick={handleToggleCartPage} 
                          style={{ cursor: 'pointer' }} 
                        >
                          <span className="home-banner-cart-item-count">
                            <ShoppingBag size={16} />
                            {cartdata?.length} Item
                          </span>
                          <span className="home-banner-cart-amount">₹ {getCartTotal().toFixed(2)}</span>
                        </div>
                  </div> : null
                    }
                    
                </div>
            </section>

            <section> <HomeOfferCarousel /> </section>

            <section>
                <div className="product-list-outer-wrapper">
<div className='homepage-mobile-filter-button'>
            
              <button 
    className="mobile-filter-btn"
    onClick={toggleFilterSidebar}
>
    <SlidersHorizontal size={18} className="filter-icon" />
    Filter
</button>
</div>



                    {isFilterOpen && (
                        <div className="sidebar-overlay" onClick={closeFilterSidebar}></div>
                    )}
                    
                   
                    <div className={`product-list-sidebar-wrapper ${isFilterOpen ? 'sidebar-open' : ''}`}>
                        <div className="filter-top-close-btn">
                         <img src={tanuragalogo} alt="Tanuraaga" className="home-page-filter-logo" />
                            <X size={20} onClick={closeFilterSidebar} />
                        </div>

                        <ul className="product-list-category-list">
                            {categorydata.map((category, index) => (
                                <React.Fragment key={index}>
                                    <li 
                                        className={`product-list-category-item ${activecatindex === index ? 'product-list-category-item-active' : ''}`}
                                        onClick={() => handleCategoryClick(index)}
                                    >
                                        <button type="button" className="product-list-category-link">
                                            {/* <span className={`product-list-category-icon ${category.iconClass}`}></span>  */}
                                            {category.name}
                                        </button>
                                    
                                        {category.subcategories.length > 0 && (
                                            activecatindex === index ?
                                                <ChevronDown size={16} className="product-list-category-chevron" /> :
                                                <ChevronRight size={16} className="product-list-category-chevron" />
                                        )}
                                    </li>
                                    
                                    {activecatindex === index && category.subcategories.length > 0 && (
                                        <ul className="product-list-subcategory-list">
                                            {category.subcategories.map((sub, subIndex) => (
                                                <li 
                                                    key={subIndex} 
                                                    className={`product-list-subcategory-item ${activesubcatindex === sub?.id ? 'product-list-subcategory-item-active' : ''}`}
                                                    onClick={() => handleSubcategoryClick(sub?.id)}
                                                >
                                                    <button type="button" className="product-list-subcategory-link">{sub?.title}</button>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>

 
                    <div className="product-list-page-container" ref={productListingRef}>
                        <div className="product-list-main-content">
                            <div className="product-list-section-head">
                                <div>
                                    <span className="product-list-kicker">
                                        {activeSearch ? "Search Results" : "Fresh From Tanuraaga"}
                                    </span>
                                    <h2>
                                        {activeSearch ? `Showing matches for "${activeSearch}"` : "Shop The Collection"}
                                    </h2>
                                </div>
                                {activeSearch && (
                                    <button className="product-list-clear-search" onClick={clearSearch}>
                                        <X size={16} />
                                        Clear Search
                                    </button>
                                )}
                            </div>
                        
                            
                                {
                                    productsdata?.length > 0 ?
                                    <div className="product-list-grid">
                                        {
                                            productsdata?.map((item, index) => {
                                                const imagesarr = item?.imagesarr ? JSON.parse(item?.imagesarr) : [];
                                                var discountpercent = getDiscountPercent(item?.mrpprice, item?.sellingprice);
                                                const isOutOfStock = Number(item?.stock || 0) <= 0;
                                                console.log('discountpercent >>', discountpercent);
                                                
                                                return (
                                                  <div
                                                    key={index}
                                                    className="product-list-card"
                                                  >
                                                    {discountpercent > 0 && (
                                                      <span className="product-list-badge">
                                                        {discountpercent} % OFF
                                                      </span>
                                                    )}
                                                    {isOutOfStock && (
                                                      <span className="product-list-badge product-list-stock-badge">
                                                        Out of Stock
                                                      </span>
                                                    )}
                                                    <div className="product-list-image-container">
                                                        {
                                                            imagesarr[0] ?
                                                            <img
                                                        src={assetsUrl+"products/"+imagesarr[0]}
                                                        alt={item?.name}
                                                        className="product-list-image"
                                                      /> : 
                                                      <img
                                                      src={noimage}
                                                      alt={item?.name || "Product"}
                                                      className="product-list-image"
                                                    />
                                                        }
                                                        
                                                    </div>
                                                    <div className="product-list-details">
                                                      <h3 className="product-list-name">
                                                        {item?.name}
                                                      </h3>
                                                      <div className="product-list-price-add">
                                                        <div className="product-list-prices">
                                                          {item?.mrpprice !== item?.sellingprice && (
                                                            <span className="product-list-original-price">
                                                              {
                                                                "₹"+item?.mrpprice
                                                              }
                                                            </span>
                                                          )}
                                                          <span className="product-list-price">
                                                          ₹{item?.sellingprice}
                                                          </span>
                                                        </div>
                                                        <button
                                                          className={`product-list-add-button ${isOutOfStock ? "product-list-add-button-disabled" : ""}`}
                                                          disabled={isOutOfStock}
                                                          onClick={() => {
                                                            if (!isOutOfStock) {
                                                              handleOpenModal(item);
                                                            }
                                                          }}
                                                        >
                                                          <Plus size={16} />
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                            })
                                        }
                                    </div> :
                                    productloading ?
                                    <Spinner color='#d9a371' size={22} className='spinnerCenter' /> :
                                    <p className='no-products-text'>
                                      {activeSearch ? "No products matched your search" : "No products in selected category"}
                                    </p>
                                }



                                {/* <br /><br />
                                <div className="product-list-grid">
                                {products.map(item => (
                                    <div key={item?.id} className="product-list-card">
                                        {item?.badge && (<span className="product-list-badge">{item?.badge}</span>)}
                                        <div className="product-list-image-container">
                                            <img src={item?.image} alt={item?.name} className="product-list-image" />
                                        </div>
                                        <div className="product-list-details">
                                            <h3 className="product-list-name">{item?.name}</h3>
                                            <div className="product-list-price-add">
                                                <div className="product-list-prices">
                                                    {item?.originalPrice && (<span className="product-list-original-price">{item?.originalPrice}</span>)}
                                                    <span className="product-list-price">{item?.priceRange}</span>
                                                </div>
                                                <button 
                                                    className="product-list-add-button"
                                                    onClick={() => handleOpenModal(item)}
                                                >
                                                    <Plus size={16} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                </div> */}
                                

                        </div>
                    </div>
                </div>
            </section>


            {isModalOpen && selectedProduct && (
                <ProductDetailsModal product={selectedProduct} onClose={handleCloseModal} />
            )}
            
            {isCartPageOpen && (
                <CartPage onClose={handleToggleCartPage} />
            )}
                    
        </div>
    )
}

export default HomePage;
